import { ProjectEnvironment } from '../models/project-environment.model';

/**
 * Bestandsläufe tragen Codes (`STAGING`, `LOCAL` …), neue Läufe den Namen der Projekt-Umgebung
 * (NEX-2283). Beides gilt als dieselbe Umgebung; der Assistent schlägt „Produktion“ vor, der Bestand
 * heißt „Production“. Das Backend setzt dieselben Paare im Umgebungsfilter gleich (`EnvironmentFilter.matchValues`).
 */
const ALIASE: Readonly<Record<string, string>> = {
  LOKAL: 'LOCAL',
  PRODUKTION: 'PRODUCTION',
};

/** Vergleichsschlüssel einer Umgebung: getrimmt, groß geschrieben, Aliase auf den Code abgebildet. */
export function umgebungsSchluessel(wert: string | null | undefined): string {
  const schluessel = (wert ?? '').trim().toUpperCase();
  return ALIASE[schluessel] ?? schluessel;
}

/** Ob zwei gespeicherte Werte dieselbe Umgebung meinen; fehlende Werte meinen keine. */
export function gleicheUmgebung(a: string | null | undefined, b: string | null | undefined): boolean {
  const schluessel = umgebungsSchluessel(a);
  return schluessel !== '' && schluessel === umgebungsSchluessel(b);
}

/** Die Projekt-Umgebung, die ein gespeicherter Wert (Code oder Name) meint, sonst `null`. */
export function findeUmgebung(
  liste: readonly ProjectEnvironment[],
  wert: string | null | undefined,
): ProjectEnvironment | null {
  return liste.find((umgebung) => gleicheUmgebung(umgebung.name, wert)) ?? null;
}

/** Vorbelegung einer Umgebungsauswahl: „Staging“, falls das Projekt sie hat, sonst die erste. */
export function vorbelegteUmgebung(liste: readonly ProjectEnvironment[]): ProjectEnvironment | null {
  return findeUmgebung(liste, 'Staging') ?? liste[0] ?? null;
}
